import { cn } from '@worldcoo/ui/lib/utils';
import { Image } from '../../-components/image';

/** Matches the `size-12` of the chip, and sizes the CDN request. */
const LOGO_HEIGHT = 48;

/** Same fallback as the portal header logo; only feeds the CDN width, since the chip is square. */
const DEFAULT_LOGO_ASPECT_RATIO = 3;

function logoAspectRatio(logo: { width: number; height: number }) {
	return logo.width && logo.height ? logo.width / logo.height : DEFAULT_LOGO_ASPECT_RATIO;
}

export function CampaignNgosInline(props: {
	ngos: {
		id: string;
		name?: string;
		logo?: { location: string; width: number; height: number };
	}[];
	className?: string;
}) {
	const ngos = props.ngos
		.filter((ngo) => ngo.name ?? ngo.logo)
		// Same order as the desktop card.
		.sort((a, b) => a.name?.localeCompare(b.name ?? '') ?? 0);

	if (ngos.length === 0) return null;

	return (
		<div className={cn('flex flex-wrap items-center gap-x-6 gap-y-2', props.className)}>
			{ngos.map((ngo) => (
				<div key={ngo.id} className="flex items-center gap-2">
					{ngo.logo ? (
						/* Big and padded enough that a wordmark under the emblem stays readable letterboxed. */
						<Image
							src={ngo.logo.location}
							alt={ngo.name ?? ''}
							height={LOGO_HEIGHT}
							aspectRatio={logoAspectRatio(ngo.logo)}
							objectFit="contain"
							className="border-border size-12 shrink-0 rounded-lg border bg-white object-contain! p-1"
						/>
					) : (
						<div className="border-border bg-secondary size-12 shrink-0 rounded-lg border" />
					)}
					<span className="font-medium">{ngo.name}</span>
				</div>
			))}
		</div>
	);
}
